import { Injectable } from '@angular/core';

import { ClaimsService, ContentLink, CookieService, UserService } from '@frontend/vanilla/core';
import { LoyaltyLoginService, LoyaltyLoginValidation } from '@frontend/vanilla/features/loyalty-login';

import { Offer } from '../offers/models';
import { TrackingModelService } from '../tracking/tracking-model-service';

@Injectable({
    providedIn: 'root',
})
export class BetstationOfferService {
    private readonly NativeApp = 'NativeApp';
    isPopUpOpened: boolean = false;

    constructor(
        private cookieService: CookieService,
        private userService: UserService,
        private trackingModelService: TrackingModelService,
        private claimsService: ClaimsService,
        private loyaltyLoginService: LoyaltyLoginService,
    ) {}

    navigateToOfferMoreInfo(teaserNumber: number, offer: Offer, slipId: string = '') {
        if (this.loyaltyLoginService?.loyaltyValidation != null && Object.keys(this.loyaltyLoginService?.loyaltyValidation)?.length > 0) {
            const res = this.loyaltyLoginService.loyaltyValidation;
            this.generateUrl(res, offer);
        }
        const moreInfoCta = offer.offerContent.moreInfoCta;
        this.trackBetStationClick(offer, 'more info', teaserNumber, moreInfoCta);

        const moreInfoUrlLowerCase = moreInfoCta?.url?.toLowerCase();
        const ctaUrl = new URL(moreInfoCta?.url);
        const cookieValue = this.cookieService.get(this.NativeApp);
        if (!moreInfoUrlLowerCase?.includes('_nativeapp')) {
            ctaUrl?.searchParams?.append('_nativeapp', cookieValue);
        }
        if (slipId && !moreInfoUrlLowerCase?.includes('slipId')) {
            ctaUrl?.searchParams?.append('slipId', slipId);
        }
        if (!moreInfoUrlLowerCase?.includes('.box')) {
            ctaUrl?.searchParams?.append('.box', '1');
        }
        if (this.userService.isAuthenticated && this.userService.ssoToken) {
            ctaUrl.searchParams?.append('_ssotoken', this.userService.ssoToken);
        }
        const requiredModalData = {
            url: ctaUrl?.href,
            overlayTitle: offer?.offerContent?.title,
        };
        return requiredModalData;
    }

    generateUrl(res: LoyaltyLoginValidation, offer: Offer) {
        if (offer?.offerMetadata?.specialOfferName == 'onetwofree') {
            const loyaltyAccountName = res.loyaltyAccountName;
            const loyaltyCardNo = res.loyaltyCardNo;
            const shopId = this.cookieService.get('shop_id');
            const terminalId = this.cookieService.get('terminal_id');
            const rawTerminalAccountName = this.claimsService.get('http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier');
            const terminalAccountName = rawTerminalAccountName !== null ? rawTerminalAccountName : '';
            const moreInfoUrl = offer.offerContent.moreInfoCta.url;
            const url = new URL(offer.offerContent.moreInfoCta.url);
            if (!moreInfoUrl?.includes('loyaltyAccountName') && loyaltyAccountName) {
                url.searchParams?.append('loyaltyAccountName', loyaltyAccountName);
            }
            if (!moreInfoUrl?.includes('loyaltyCardNo') && loyaltyCardNo) {
                url.searchParams?.append('loyaltyCardNo', loyaltyCardNo);
            }
            if (!moreInfoUrl?.includes('shopId') && shopId) {
                url.searchParams?.append('shopId', shopId);
            }
            if (!moreInfoUrl?.includes('terminalId') && terminalId) {
                url.searchParams?.append('terminalId', terminalId);
            }
            if (!moreInfoUrl?.includes('terminalAccountName') && terminalAccountName) {
                url.searchParams?.append('terminalAccountName', terminalAccountName);
            }

            offer.offerContent.moreInfoCta.url = url?.href;
        }
    }

    trackBetStationClick(offer: Offer, positionEvent: string, position: any, cta: ContentLink) {
        this.trackingModelService.submitTracking({
            CategoryEvent: 'promotions',
            LabelEvent: 'bet station offers',
            ActionEvent: 'click',
            PositionEvent: offer?.offerMetadata?.applicableProducts?.join('|'),
            LocationEvent: offer?.offerContent?.title,
            EventDetails: positionEvent,
            URLClicked: cta?.url,
            contentPosition: position,
        });
    }

    updatePopupInfo(isPopUpOpened: boolean) {
        this.isPopUpOpened = isPopUpOpened;
    }

    getPopupInfo(): boolean {
        return this.isPopUpOpened;
    }
}
